import JovSSN from './JovSSNContainer';

export default JovSSN;